import React from "react";
import Layout from "../Navbar";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { FourNOTFour } from "./../../Public/assets";

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <Layout noToggle={false} footer={false}>
      <div className="flex flex-col items-center justify-center text-center  py-[191px] bg-Landing-Background bg-cover bg-no-repeat  h-[100dvh]">
        <div className="space-y-[14px] md:space-y-[19px]   ">
          <img
            src={FourNOTFour}
            alt=""
            className="w-[260px] sm:w-[360px] m-auto  md:w-[460px] lg-[560px] xl:w-[680px]"
          />
          <h1
            className=" flex flex-col md:gap-2  md:flex-row md:justify-center text-[28px] md:font-[700] font-geomanistBold md
          :text-[42px]   md:leading-[65px] "
          >
            <span className="font-[700] font-geomanistBold text-[42px] md:leading-[65px]  text-blueish">
              Oops!
            </span>
            Page Not Found
          </h1>
          <p className="px-4 text-[14px] md:text-[18px] font-[400] leading-[22px]  text-blackShade">
            Looks like the page you're looking for doesn't exist or may have
            been moved.
          </p>
          <Button
            className={` w-auto px-[22px] py-[19px]`}
            onClick={() => navigate("/")}
          >
            Go Back To Home
          </Button>
        </div>
      </div>
    </Layout>
  );
}

export default PageNotFound;
